<template>
  <v-container fluid>
    <v-card flat>
      <v-form
        v-model="isGood"
        class="d-flex justify-center"
      >
        <v-card
          v-if="sizeRequired"
          flat 
          class="pa-4"
        >
          <v-radio-group
            v-model="vote.size"
            label="Size"
            :rules="rules.required"
          >
            <v-radio
              v-for="size in properties.sizes"
              :key="size"
              :label="size"
              :value="size"
              color="tan"
            />
          </v-radio-group>
        </v-card>

        <v-card
          v-if="colorRequired"
          flat
          class="pa-4"
        >
          <v-radio-group
            v-model="vote.color"
            label="Color"
            :rules="rules.required"
          >
            <v-radio
              v-for="color in properties.colors"
              :key="color"
              :label="color"
              :value="color"
              color="tan"
            />
          </v-radio-group>
        </v-card>

        <v-card
          flat
          class="pa-4 pt-8"
        >
          <v-text-field
            v-if="properties.show_quantity"
            v-model="vote.qty"
            type="number"
            label="Qty"
            append-outer-icon="mdi-plus-circle"
            prepend-icon="mdi-minus-circle"
            :rules="rules.notZero"
            @click:append-outer="increment"
            @click:prepend="decrement"
          />
        </v-card>
      </v-form>

      <v-card-actions
        class="justify-end"
      >
        <v-btn
          block
          type="submit"
          elevation="0"
          color="primary"
          :disabled="!isGood"
          @click="addToCart"
        >
          Add to Cart
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: 'item',
  props: ['item'],
  data: () => {
    return {
      vote: {
        qty: 1,
        color: null,
        size: null
      },
      rules: {
        required: [v => !!v],
        notZero: [v => v>=1]
      },
      isGood: false
    }
  },
  computed: {
    properties(){return this.item.properties || {}},
    sizeRequired(){return !!(this.properties.sizes || []).length},
    colorRequired(){return !!(this.properties.colors || []).length},
  },
  methods: {
    increment () {
      this.vote.qty = parseInt(this.vote.qty,10) + 1
    },
    decrement () {
      if (this.vote.qty > 1) {
        this.vote.qty = parseInt(this.vote.qty,10) - 1
      }
    },
    addToCart(){
      this.$store.commit('market/addToCart', {
        shopID: this.context,
        item: this.item,
        vote: this.vote,
      })
      this.$emit('close')
    }
  }
}
</script>